export const SHOW_ALERT = "SHOW_ALERT"
export const HIDE_ALERT = "HIDE_ALERT"
export const RELOAD_ON_DEMAND = "RELOAD_ON_DEMAND"
